export default [
    {
        definition: 'The percentage of households in a given category that have one or more TTD conversion activities attributed to them in the past 100 days.',
        displayName: 'Conversion Rate'
    },
    {
        definition: 'The percent increase in conversion rate of households exposed to multiple channels vs. a single channel.',
        displayName: 'Lift'
    },
    {
        definition: 'An audience segment that is based on IP address with less than 15 device IDs associated with it. Household audiences are used to extend targeting from a single device to all devices associated with a specific household.',
        displayName: 'Household'
    },
    {
        definition: 'Any conversion pixel that is fired from a device associated with a household is counted as a household conversion.',
        displayName: 'Household Conversion'
    },
    {
        definition: 'Households exposed to exclusively one tactic (Display, CTV, etc.) within the past 100 days.',
        displayName: 'Single Channel Households'
    },
    {
        definition: 'A household exposed to a combination of two or more tactics within the past 100 days.',
        displayName: 'Multi Channel Households'
    }
];



// WEBPACK FOOTER //
// ./src/constants/glossaries/CrossChannelGlossary.js